import { render, staticRenderFns } from "./getUserOpenid.vue?vue&type=template&id=9a67c61c&scoped=true&"
import script from "./getUserOpenid.vue?vue&type=script&lang=js&"
export * from "./getUserOpenid.vue?vue&type=script&lang=js&"
import style0 from "./getUserOpenid.vue?vue&type=style&index=0&id=9a67c61c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a67c61c",
  null
  
)

export default component.exports